export default __webpack_public_path__ + "static/media/game-x.9ac59185.png";